// How far the Team directory chart is zoomed. It's each person's own, kept in this
// browser like the theme (lib/themeChoice.js), and it stays through sign out
// (helpers/auth.js), because it says nothing about the workspace.
export const ORG_CHART_ZOOM_KEY = "bd:orgChartZoom";
export const ORG_CHART_ZOOM_MIN = 40;
export const ORG_CHART_ZOOM_MAX = 160;
export const ORG_CHART_ZOOM_STEP = 10;
export const ORG_CHART_ZOOM_DEFAULT = 100;

/** A whole step inside the range, or 100% for anything that isn't a number. */
export function cleanOrgChartZoom(value) {
  const percent = Number(value);
  if (value === null || value === "" || !Number.isFinite(percent)) return ORG_CHART_ZOOM_DEFAULT;
  const stepped = Math.round(percent / ORG_CHART_ZOOM_STEP) * ORG_CHART_ZOOM_STEP;
  return Math.min(ORG_CHART_ZOOM_MAX, Math.max(ORG_CHART_ZOOM_MIN, stepped));
}

export function readOrgChartZoom() {
  try {
    return cleanOrgChartZoom(localStorage.getItem(ORG_CHART_ZOOM_KEY));
  } catch {
    return ORG_CHART_ZOOM_DEFAULT;
  }
}

export function saveOrgChartZoom(percent) {
  try {
    localStorage.setItem(ORG_CHART_ZOOM_KEY, String(percent));
  } catch {}
}
